import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from '@criteria-labs/react';
export function ExecutingView() {
    return (_jsx("div", { className: "flex h-full w-full items-center justify-center overflow-clip py-2", children: _jsxs("p", { className: "flex items-center gap-2 text-center text-xs text-zinc-700 dark:text-white/70", children: [_jsx(Spinner, { className: "h-3 w-3" }), "Sending\u2026"] }) }));
}
